export interface IVatDetails {
    rate: number | null,
}



export const vatInitValues: IVatDetails = {
    rate: null,
}
